import { createApp } from 'vue'
import App from './App.vue'
import { store } from './store/store'
import { router } from './routes'
import Swal from 'sweetalert2'

import './styles.css' 

const app = createApp(App)

app.config.globalProperties.$swal = Swal 

app.use(store)
app.use(router)

app.mount('#app')